import React,{ useState } from 'react';
import TopPanel from './TopPanel.jsx';
import { signOut } from 'aws-amplify/auth';

import {
  useLocation,
  useNavigate,
  useParams
} from "react-router-dom";
import {
  SideNavigation,
  Box,
  Badge,
} from '@cloudscape-design/components';
import AnchorNavigation from "@cloudscape-design/components/anchor-navigation";
import DataProvider from '../resources/data-provider';
import {TREND_ANALYSIS_ENDPOINT} from '../resources/prod-env.jsx';

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}

// Component ServiceNavigation is the Side Navigation component that is used in BasicLayout, CreateForm, ServiceHomepage, and Table flows.
// Implement like this: <ServiceNavigation />
function ServiceNavigation(props) {
  // If the provided link is empty, do not redirect pages
  const navigate = useNavigate();
  let location = useLocation();
  let dataProvider = new DataProvider();
  const [access, setAccess] = useState(false);

  React.useEffect(() => {
    // Only attempt access check if user prop is provided
    if(!props?.user){
      console.log("No user prop provided to ServiceNavigation");
      setAccess(false);
      return;
    }
    
    let user = props.user;
    // Check if user has storage property (custom auth) before accessing
    if (!user.storage || !user.keyPrefix) {
      console.log("OAuth user detected, skipping access check");
      setAccess(false);
      return;
    }
    let key = user.keyPrefix+"."+user.username+".accessToken";
    // console.log(key);
    let authKey = user.storage[key];
    if (!authKey) {
      console.log("No access token found in storage");
      setAccess(false);
      return;
    }
    let url=`/checkaccess?token=${authKey}`;
    dataProvider.getAPIData(url, response => {
      if(response && !response.error && response['log'] == "You are authorized!") {
        setAccess(true);
      } else {
        if (response?.error) {
          console.log("Access check failed:", response.message || response.status);
        }
        setAccess(false);
      }
    });
  }, [props?.user]);

  // let checkAccess = async() => {
  //   if(props?.user){
  //     let user = props.user;
  //     let key = user.keyPrefix+"."+user.username+".accessToken";
  //     // console.log(key);
  //     let authKey = user.storage[key];
  //     let url=`/checkaccess?token=${authKey}`;
  //     dataProvider.getAPIData(url,response => {
  //       if(response['log'] == "You are authorized!")
  //       return true;
  //       else
  //       return false;
  //     });
  // }
  // };

  // let access = checkRestrictedAccess(props?.user).then(resp => {return resp});
  console.log("Access "+access);

  // async function checkRestrictedAccess(user){
  //   console.log("In checkRestrictedAccess "+user);
  //           // console.log(user);
  //   if(user){
  //       let key = user.keyPrefix+"."+user.username+".accessToken";
  //       // console.log(key);
  //       let authKey = user.storage[key];
  //       let url=`/checkaccess?token=${authKey}`;
  //       let response = await new Promise(resolve => {
  //         dataProvider.getAPIData(url,resolve);
  //       });
  //       console.log("Response ",response);
  //       if(response['log'] == "You are authorized!")
  //       return true;
  //       else
  //       return false;
  //   }
  //   return false;
  // }

  function onFollowHandler(ev) {
    ev.preventDefault();
    // console.log(ev);
    
    // Handle external links (URLs starting with http/https) - open in new window
    if (ev.detail.href?.startsWith('http')) {
      window.open(ev.detail.href, '_blank', 'noopener,noreferrer');
      return;
    }
    
    // Handle sign-out specially
    if (ev.detail.href == "/login") {
      handleSignOut();
      return;
    }
    
    navigate(ev.detail.href);
    // props.navigate(ev.detail.href);
    if (ev.detail.href == "/wafcaptcha") {
      location.reload();
    }
  }

  async function handleSignOut() {
    try {
      console.log("Signing out user...");
      
      // Clear all localStorage items
      localStorage.removeItem("user");
      localStorage.removeItem("userId");
      localStorage.removeItem("userProfile");
      localStorage.removeItem("lastUrl");
      
      // Sign out from Cognito
      await signOut({ global: true });
      
      console.log("User signed out successfully");
      
      // Force reload to clear any cached state and navigate to login
      window.location.href = "/login";
    } catch (error) {
      console.error("Error signing out:", error);
      // Even if sign-out fails, clear local data and redirect
      localStorage.clear();
      window.location.href = "/login";
    }
  }

  return (
    <React.Fragment>
      <SideNavigation
        // header={{ href: "/", text: <Box variant='h5'>Edge Services Demos</Box> }}
        items={items}
        onFollow={onFollowHandler}
      />
      {/* {access &&     <>       <hr />
 <SideNavigation
        items={itemsRestricted}
        onFollow={onFollowHandler}
      /></>} */}
      <hr />
      <SideNavigation
        items={itemsOthers}
        onFollow={onFollowHandler}
      />
    </React.Fragment>
  );
}

const items1 = [
  {
    text: "CloudFront",
    level: 1
  },
  {  text: "Acceleration", 
     href: '/acceleration', 
     level: 2
  },
  {  text: "Signed URLs", 
     href: '/signedurl', 
     level: 2
  }
];

const items = [
  {
    type: 'section',
    text: <Box variant='strong'>CloudFront</Box>,
    items: [
      { type: 'link', text: <Box>Acceleration</Box>, href: '/acceleration' },
      { type: 'link', text: <Box>Signed URLs</Box>, href: '/signedurl' },
      { type: 'link', text: <Box>CMCD</Box>, href: '/cmcd' },
      { type: 'link', text: <Box>Caching</Box>, href: '/caching' },
      { type: 'link', text: <Box>Image Optimization</Box>, href: '/image' },
      { type: 'link', text: <Box>Origin Failover </Box>, href: '/failover' },
    ]
  },
  {
    type: 'section',
    text: <Box variant='strong'>Edge Functions</Box>,
    items: [
      { type: 'link', text: <Box>Inspect Request <Badge color='grey'>maintenance</Badge></Box>, href: '/inspect' },
      { type: 'link', text: 'URL Normalization', href: '/urlnormalization' },
      { type: 'link', text: 'JWT Auth', href: '/jwtauth' },
      { type: 'link', text: 'A/B Testing', href: '/abtesting' }
    ]
  },
  {
    type: 'section',
    text: <Box variant='strong'>Observability</Box>,
    items: [
      {
        type: 'link', text: <Box>Multi-CDN <Badge color='blue'>beta</Badge></Box>, href: '/multicdn'
      },
      {
        type: 'link', text: <Box>Website Performance <Badge color='blue'>beta</Badge></Box>, href: '/cfrum'
      },
      { type: 'link', text: <Box>WAF Logs</Box>, href: '/wafdashboard' },

    ]
  },
  {
    type: 'section',
    text: <Box variant='strong'>WAF</Box>,
    items: [
      {
        type: 'link', text: <Box>SQLi/XSS</Box>, href: '/wafsqli'
      },
      {
        type: 'link', text: <Box>RBR</Box>, href: '/wafrbr'
      },
      {
        type: 'link', text: <Box>ATP</Box>, href: '/wafatp'
      },
      { type: 'link', text: <Box>CAPTCHA</Box>, href: '/wafcaptcha' },
      {type: 'link', text: <Box>Custom Request/Response</Box>, href: '/wafcustom'},
      { type: 'link', text: <Box>Monetization <Badge color='blue'>experimental</Badge></Box>, href: '/wafmonetization' },
      { type: 'link', text: <Box>Edge Experience Center</Box>, href: '/edgeexperience' },
    ]
  },
  {
    type: 'section',
    text: <Box variant='strong'>Video</Box>,
    items: [
      { type: 'link', text: <Box>Video Comparitor</Box>, href: '/videocomparitor' },
      // { type: 'link', text: <Box>Channel Selector < sup className='text_color_red' > <i>BETA</i></sup></Box>, href: '/simplechannelselector' },
    ]
  },
  {
    type: 'section',
    text: <Box variant='strong'>Tools</Box>,
    items: [
      { type: 'link', text: <Box>CDN Finder</Box>, href: '/cdnfinder' },
      // { type: 'link', text: <Box>CDN Finder <Badge color='red'>maintenance</Badge></Box>, href: '/cdnfinder' },
      { type: 'link', text: <Box>Discover Content (Edge)</Box>, href: '/contentdiscovery' },
      // { type: 'link', text: <Box>Discover Content (Media)</Box>, href: '/mediacontentdiscovery' },
      { type: 'link', text: <Box>Check Idea </Box>, href: '/checkidea' },
      { type: 'link', text: <Box>Edge Configurator <Badge color='blue'>experimental</Badge></Box>, href: '/edgeconfigurator' },
      { type: 'link', text: <Box>RID Analyzer <Badge color='blue'>experimental</Badge></Box>, href: '/ridanalyzer' },
      { type: 'link', text: <Box>Steering Generator</Box>, href: '/steeringgenerator' },
      // { type: 'link', text: <Box>Spec Req <Badge color='blue'>restricted</Badge></Box>, href: '/specreq' },
      { type: 'link', text: <Box>Blog Checker</Box>, href: '/blogchecker' },
      { type: 'link', text: <Box>Image Search <Badge color='blue'>experimental</Badge></Box>, href: '/imagesearch' },
      { type: 'link', text: <Box>Networking Architecture Builder</Box>, href: '/networkingbuilder' },
    ]
  },
];

const itemsRestricted = [
  // {
  //   type: 'link',
  //   text: <Box>Trends - SpecReq<Badge color='red'>restricted</Badge></Box>,
  //   href: '/specreq'
  // },
]

const itemsOthers = [
  {
    type: 'link',
    text: 'Resources',
    href: '/resources'
  },
  {
    type: 'link',
    text: 'Feedback',
    href: '/feedback'
  },
  {
    type: 'link',
    text: <Box>Usage Stats</Box>,
    href: '/usagestats'
  },
  {
    type: 'link',
    text: 'Sign-In/Sign-out',
    href: '/login'
  }
];
export default withRouter(ServiceNavigation);
